import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import WithDraggableList from 'Pods/Shared/Hocs/WithDraggableList'

class ActiveFilters extends React.Component {
  componentDidUpdate(prevProps) {
    if (prevProps.tags.length !== this.props.tags.length) {
      this.props.onUpdate()
    }
  }

  render() {
    return (
      <ul className="job-list-item__labels">
        {this.props.tags.map((key, index) => {
          if (key) {
            return (
              <li
                key={`active-tag-${key}-${index}`}
                className="label label--white label--flat label--remove"
              >
                {`${key} `}
                <span
                  className="label__remove-icon"
                  onClick={() => { this.props.onClick(key) }}
                >
                  <Icon type={['far', 'times']} notSpaced />
                </span>
              </li>
            )
          }
        })}
      </ul>
    )
  }
}

ActiveFilters.propTypes = {
  onClick: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  tags: PropTypes.array,
}

ActiveFilters.defaultProps = {
  tags: [],
}

export default WithDraggableList(ActiveFilters)
